import { render } from "./index.vue?vue&type=template&id=08dc73e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=08dc73e8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-08dc73e8"

export default script